export default "__VITE_ASSET__BV71nU4m__"